import React from 'react';
import { Outlet } from 'react-router-dom';
import { uiClasses } from '../components/common/uiClasses';

export function AuthLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className={`${uiClasses.pageShell} flex items-center justify-center px-4 py-8`}>
      {children ?? <Outlet />}
    </div>
  );
}
